import Slider from "./slider";
export default Slider;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ant-design/react-slick/es/index.js
// module id = 756
// module chunks = 0